import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import {
	SimpleSearchField as SimpleSearchFieldNew,
	SimpleSearchTextField as SimpleSearchTextFieldNew,
	// eslint-disable-next-line jira/import/no-parent-imports
} from '../simple-search-field-new';
import {
	SimpleSearchField as SimpleSearchFieldOld,
	SimpleSearchStatelessField as SimpleSearchStatelessFieldOld,
	// eslint-disable-next-line jira/import/no-parent-imports
} from '../simple-search-field-old';

export const SimpleSearchTextField = componentWithFG(
	'jwm_update_simple_search_field',
	SimpleSearchTextFieldNew,
	SimpleSearchStatelessFieldOld,
);

export const SimpleSearchField = componentWithFG(
	'jwm_update_simple_search_field',
	SimpleSearchFieldNew,
	SimpleSearchFieldOld,
);

export default componentWithFG(
	'jwm_update_simple_search_field',
	SimpleSearchFieldNew,
	SimpleSearchFieldOld,
);
